import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    allCountries: [],
    allPassportCountries: [],
  },
  getters: {
    byCountryById: (state) => (countryid) => {
      if (state.allCountries && state.allCountries.length > 0) {
        // find country by id
        const c = state.allCountries.find((c) => c.id === countryid);
        return c;
      }
      return null;
    },
    allCountries: (state) => {
      if (state.allCountries) {
        const countries = state.allCountries;
        countries.forEach((country) => {
          if (country.id == 84) country.regions = country.regions.filter((reg) => reg.id != 5);
        });
        return countries;
      }
    },
    allPassportCountries: (state) => {
      if (state.allPassportCountries) {
        return state.allPassportCountries;
      }
    },
    allCountriesSortedCustom: (state) => {
      if (state.allCountries) {
        const newCountries = state.allCountries;
        newCountries.unshift({ id: null, name: '-----------------------------------', code: null });

        // move some countries to the start of the list
        // moveToFront(newCountries, 'CH')
        // moveToFront(newCountries, 'US')
        // moveToFront(newCountries, 'GB')
        // moveToFront(newCountries, 'RU')
        // moveToFront(newCountries, 'IT')
        // moveToFront(newCountries, 'HK')
        // moveToFront(newCountries, 'DE')
        // moveToFront(newCountries, 'FR')
        // moveToFront(newCountries, 'CA')
        // moveToFront(newCountries, 'AU')

        const frontCountries = ['CH',
          'US',
          'GB',
          'RU',
          'IT',
          'HK',
          'DE',
          'FR',
          'CA',
          'AU',
        ];

        copyToFront(newCountries, frontCountries);

        function copyToFront(arr, arr2) {
          arr2.forEach((code) => {
            const x = arr.find((c) => c.code === code);
            x ? arr.unshift(x) : null;
          });
          return arr;
        }

        // function moveToFrontOld(arr, code) {
        //   arr.sort(function (x, y) { return x.code == code ? -1 : y.code == code ? 1 : 0; });
        //   return arr
        // }
        return newCountries;
      }
    },
  },
  mutations: {
    setAllCountries(state, countries) {
      state.allCountries = countries;
    },
    setAllPassportCountries(state, countries) {
      state.allPassportCountries = countries;
    },
  },
  actions: {
    // fetchAllCountries({ commit, dispatch, getters }) {
    //  axios.get('/core/countries/language/en') // no multi lang - always return EN
    //    .then((res) => {
    //      commit('setAllCountries', res.data);
    //    })
    //    .catch((error) => console.log(error));
    // },
    fetchAllPassportCountries({ commit, dispatch, getters }) {
      return new Promise((resolve, reject) => {
        axios.get('/core/countries/passport/language/en') // no multi lang - always return EN
          .then((res) => {
            commit('setAllPassportCountries', res.data);
            resolve(res.data);
          });
      })
        .catch((error) => console.log(error));
    },
  },
};
